import React from 'react';
import Grid from '@mui/material/Grid';
import LoadingDialog from '../../Loading';
import Typography from '@mui/material/Typography';
import {
    InspectionContents,
    InspectionName
} from '../../css/CSS.js';
import CssBaseline from '@mui/material/CssBaseline';

import { ThemeProvider, createTheme } from '@mui/material/styles'

import PosFileForm from './PosFileForm';
import AttachedFilesForm from './attachedFilesForm';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const inspectionTheme = createTheme({
    palette: {
        background: {
            default: '#f8f7f6'
        }
    }
})




export default function OperateForm(props) {

    const PDFOpen = () => {
        window.open(props.PDFFile)
    };

    return (
        <React.Fragment>
            <ThemeProvider theme={inspectionTheme}>
                <Grid style={{ position: "relative" }} >
                    <LoadingDialog load={false} />
                    <CssBaseline />
                    <InspectionContents sx={{ pt: 2 }}>
                        <Grid container columns={12} spacing={0} sx={{ alignItems: 'flex-start' }} >
                            <Grid item xs={12} >
                                <InspectionName style={{ display: 'flex', paddingBottom: 0, paddingLeft: 0, paddingRight: 0 }}>
                                    <Typography
                                        sx={{ border: 1, width: '100%', height: 55, fontSize: '1.5rem', backgroundColor: '#f5f8fa'}}
                                    >
                                        <Grid container columns={12} spacing={0} sx={{ alignItems: 'flex-start', justifyContent: "space-between" }}>
                                            <Grid item xs={10} sx={{ mt: 1.1, ml: 1 }}>
                                                {props.PDFTitle}
                                            </Grid>
                                            <Grid item xs={1} sx={{ justifyContent: 'flex-end' }}>
                                                < OpenInNewIcon
                                                    fontSize="large"
                                                    sx={{ mt: 1 }}
                                                    onClick={PDFOpen}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Typography>
                                </InspectionName>
                            </Grid>
                        </Grid>
                        <Grid container sx={{ alignItems: "center", pt: 3, pb: 3, }} >
                            <Grid item xs={12} >
                                <PosFileForm
                                    keyData={props?.keyData}
                                    posStatus={props?.posStatus}
                                    setPosStatus={props?.setPosStatus}
                                    posData={props?.posData}
                                    setPosData={props?.setPosData}
                                    latitude={props?.latitude}
                                    mapLink={props?.mapLink}
                                    setMapLink={props?.setMapLink}
                                />
                            </Grid>
                        </Grid>

                        <Grid container sx={{ alignItems: "center", pt: 1, pb: 3, }} >
                            <Grid item xs={12} >
                                <AttachedFilesForm
                                    keyData={props?.keyData}
                                    attachedFileStatus={props?.attachedFileStatus}
                                    setAttachedFileStatus={props?.setAttachedFileStatus}
                                    attachedData={props?.attachedData}

                                    InspectionPreviewDialogOPEN={props?.InspectionPreviewDialogOPEN}
                                    PreviewImgIndex={props?.PreviewImgIndex}

                                    InspectionPreviewPDFDialogOPEN={props?.InspectionPreviewPDFDialogOPEN}
                                    PreviewPDFIndex={props?.PreviewPDFIndex}

                                    PrevDelIndex={props?.PrevDelIndex}
                                    PreviewImgDelDialog={props?.PreviewImgDelDialog}

                                    PrevPDFDelIndex={props?.PrevPDFDelIndex}
                                    PreviewPDFDelDialog={props?.PreviewPDFDelDialog}

                                />
                            </Grid>
                        </Grid>
                    </InspectionContents>
                </Grid>
            </ThemeProvider >
        </React.Fragment >
    );
}